export enum PostCommunicationContent {
  INTERNAL = 'internal',
  CLIENT = 'client',
  ACTIVITY = 'activity',
  PINNED = 'pinned',
  VERSIONS = 'versions',
}
